// import React, { useEffect, useState } from "react";
// import { useUpdatePasswordMutation } from "../../redux/api/userApi";
// import toast from "react-hot-toast";
// import SideMenu from "./SideMenu";
// import { useNavigate } from "react-router-dom";

// const UpdatePassword = () => {
//   const [oldPassword, setOldPassword] = useState("");
//   const [password, setPassword] = useState("");

//   const [updatePassword, { isLoading, error, isSuccess }] = useUpdatePasswordMutation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (error) {
//       toast.error(error?.data?.message);
//     }

//     if (isSuccess) {
//       toast.success("Password Updated");
//       navigate("/me/profile");
//     }
//   }, [error, navigate, isSuccess]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const userData = {
//       oldPassword,
//       password,
//     };

//     updatePassword(userData);
//   };

//   return (
//     <section className="max-w-4xl mx-auto md:flex my-16 px-6 py-12 bg-[#f5f5dc] shadow-sm rounded-md">
//       <SideMenu />

//       <form
//         onSubmit={handleSubmit}
//         className="flex flex-col space-y-6 w-full md:px-8 mt-8 md:mt-0"
//       >
//         <h2 className="text-2xl font-playfair text-amber-700 mb-2">
//           Update Password
//         </h2>

//         {/* Old Password */}
//         <div>
//           <label
//             htmlFor="oldPassword"
//             className="block text-sm font-sourcesans text-stone-700 mb-1"
//           >
//             Current Password
//           </label>
//           <input
//             id="oldPassword"
//             type="password"
//             required
//             value={oldPassword}
//             onChange={(e) => setOldPassword(e.target.value)}
//             className="w-full px-4 py-2 border border-stone-300 bg-white text-stone-800 placeholder-stone-500 font-sourcesans rounded-md focus:outline-none focus:ring-amber-600 focus:border-amber-600"
//             placeholder="Enter current password"
//           />
//         </div>

//         {/* New Password */}
//         <div>
//           <label
//             htmlFor="newPassword"
//             className="block text-sm font-sourcesans text-stone-700 mb-1"
//           >
//             New Password
//           </label>
//           <input
//             id="newPassword"
//             type="password"
//             required
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             className="w-full px-4 py-2 border border-stone-300 bg-white text-stone-800 placeholder-stone-500 font-sourcesans rounded-md focus:outline-none focus:ring-amber-600 focus:border-amber-600"
//             placeholder="Enter new password"
//           />
//         </div>

      

//         {/* Submit Button */}
//         <div>
//           <button
//             type="submit"
//             disabled={isLoading}
//             className="bg-amber-700 hover:bg-amber-800 text-white px-6 py-2 rounded-md text-sm font-sourcesans focus:outline-none focus:ring-2 focus:ring-amber-600"
//           >
//             {isLoading ? "Updating..." : "Update Password"}
//           </button>
//         </div>
//       </form>
//     </section>
//   );
// };

// export default UpdatePassword;

// import React, { useEffect, useState } from "react";
// import { useUpdatePasswordMutation } from "../../redux/api/userApi";
// import toast from "react-hot-toast";
// import SideMenu from "./SideMenu";
// import { useNavigate } from "react-router-dom";
// import { Helmet } from "react-helmet-async";

// const UpdatePassword = () => {
//   const [oldPassword, setOldPassword] = useState("");
//   const [password, setPassword] = useState("");

//   const [updatePassword, { isLoading, error, isSuccess }] = useUpdatePasswordMutation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (error) {
//       toast.error(error?.data?.message);
//     }

//     if (isSuccess) {
//       toast.success("Password Updated");
//       navigate("/me/profile");
//     }
//   }, [error, navigate, isSuccess]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const userData = {
//       oldPassword,
//       password,
//     };

//     updatePassword(userData);
//   };

//   const menuItems = [
//     { name: "Profile", url: "/me/profile" },
//     { name: "Edit Profile", url: "/me/update_profile" },
//     { name: "Change Password", url: "/me/update_password" },
//     { name: "Orders", url: "/me/orders" },
//   ];

//   return (
//     <>
//     <Helmet>
//         <title>Update Password</title>
//         <meta name="robots" content="noindex, nofollow" />
//       </Helmet>
//     <section className="max-w-4xl mt-20  md:mt-48 mx-auto md:flex my-16 px-6 py-12 bg-[#f5f3ea] shadow-md rounded-md">
//       <SideMenu menuItems={menuItems}/>

//       <form
//         onSubmit={handleSubmit}
//         className="flex flex-col space-y-6 w-full md:px-8 mt-8 md:mt-0 bg-white/70 backdrop-blur-sm p-6 rounded-md shadow-inner"
//       >
//         <h2 className="text-2xl font-playfair text-[#BC3F4A] mb-4 text-center md:text-left">
//           Update Password
//         </h2>

//         {/* Current Password */}
//         <div>
//           <label
//             htmlFor="oldPassword"
//             className="block text-sm font-sourcesans text-[#1c1917] mb-1"
//           >
//             Current Password
//           </label>
//           <input
//             id="oldPassword"
//             type="password"
//             required
//             value={oldPassword}
//             onChange={(e) => setOldPassword(e.target.value)}
//             placeholder="Enter current password"
//             className="w-full px-4 py-2 border border-[#8a4b32]/50 bg-white text-[#1c1917] placeholder-stone-500 font-sourcesans rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
//           />
//         </div>

//         {/* New Password */}
//         <div>
//           <label
//             htmlFor="newPassword"
//             className="block text-sm font-sourcesans text-[#1c1917] mb-1"
//           >
//             New Password
//           </label>
//           <input
//             id="newPassword"
//             type="password"
//             required
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             placeholder="Enter new password"
//             className="w-full px-4 py-2 border border-[#8a4b32]/50 bg-white text-[#1c1917] placeholder-stone-500 font-sourcesans rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
//           />
//         </div>

//         {/* Submit Button */}
//         <div>
//           <button
//             type="submit"
//             disabled={isLoading}
//             className="bg-[#BC3F4A] hover:bg-[#a3323b] text-white px-6 py-2 rounded-md text-sm font-playfair focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition w-full"
//           >
//             {isLoading ? "Updating..." : "Update Password"}
//           </button>
//         </div>
//       </form>
//     </section>
//     </>
//   );
// };

// export default UpdatePassword;

import React, { useEffect, useState } from "react";
import { useUpdatePasswordMutation } from "../../redux/api/userApi";
import toast from "react-hot-toast";
import SideMenu from "./SideMenu";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const UpdatePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");

  // ✅ Password strength state
  const [passwordStrength, setPasswordStrength] = useState({
    hasMinLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });

  const [updatePassword, { isLoading, error, isSuccess }] =
    useUpdatePasswordMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message);
    }

    if (isSuccess) {
      toast.success("Password Updated");
      navigate("/me/profile");
    }
  }, [error, navigate, isSuccess]);

  // ✅ Check password strength
  const checkPasswordStrength = (pwd) => {
    setPasswordStrength({
      hasMinLength: pwd.length >= 8,
      hasUpperCase: /[A-Z]/.test(pwd),
      hasLowerCase: /[a-z]/.test(pwd),
      hasNumber: /\d/.test(pwd),
      hasSpecialChar: /[@$!%*?&#]/.test(pwd),
    });
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    checkPasswordStrength(newPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Frontend validation
    const isPasswordValid = Object.values(passwordStrength).every(Boolean);
    if (!isPasswordValid) {
      toast.error("Please meet all password requirements");
      return;
    }

    // ✅ Check if old and new passwords are the same
    if (oldPassword === password) {
      toast.error("New password cannot be same as old password");
      return;
    }

    const userData = {
      oldPassword,
      password,
    };

    updatePassword(userData);
  };

  const menuItems = [
    { name: "Profile", url: "/me/profile" },
    { name: "Edit Profile", url: "/me/update_profile" },
    { name: "Change Password", url: "/me/update_password" },
    { name: "Orders", url: "/me/orders" },
  ];

  const isPasswordValid = Object.values(passwordStrength).every(Boolean);

  return (
    <>
      <Helmet>
        <title>Update Password</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section className="max-w-4xl mt-20 md:mt-48 mx-auto md:flex my-16 px-6 py-12 bg-[#f5f3ea] shadow-md rounded-md">
        <SideMenu menuItems={menuItems} />

        <form
          onSubmit={handleSubmit}
          className="flex flex-col space-y-6 w-full md:px-8 mt-8 md:mt-0 bg-white/70 backdrop-blur-sm p-6 rounded-md shadow-inner"
        >
          <h2 className="text-2xl font-playfair text-[#BC3F4A] mb-4 text-center md:text-left">
            Update Password
          </h2>

          {/* Current Password */}
          <div>
            <label
              htmlFor="oldPassword"
              className="block text-sm font-sourcesans text-[#1c1917] mb-1"
            >
              Current Password
            </label>
            <input
              id="oldPassword"
              type="password"
              required
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Enter current password"
              className="w-full px-4 py-2 border border-[#8a4b32]/50 bg-white text-[#1c1917] placeholder-stone-500 font-sourcesans rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
            />
          </div>

          {/* New Password */}
          <div>
            <label
              htmlFor="newPassword"
              className="block text-sm font-sourcesans text-[#1c1917] mb-1"
            >
              New Password
            </label>
            <input
              id="newPassword"
              type="password"
              required
              value={password}
              onChange={handlePasswordChange}
              placeholder="Enter new password"
              className="w-full px-4 py-2 border border-[#8a4b32]/50 bg-white text-[#1c1917] placeholder-stone-500 font-sourcesans rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
            />

            {/* ✅ Password strength indicator */}
            {password && (
              <div className="mt-3 text-xs font-sourcesans space-y-1">
                <p className="font-medium text-[#1c1917] mb-2">
                  Password must contain:
                </p>
                <div className="space-y-1">
                  <p
                    className={
                      passwordStrength.hasMinLength
                        ? "text-green-600"
                        : "text-stone-500"
                    }
                  >
                    {passwordStrength.hasMinLength ? "✓" : "○"} At least 8
                    characters
                  </p>
                  <p
                    className={
                      passwordStrength.hasUpperCase
                        ? "text-green-600"
                        : "text-stone-500"
                    }
                  >
                    {passwordStrength.hasUpperCase ? "✓" : "○"} One uppercase
                    letter
                  </p>
                  <p
                    className={
                      passwordStrength.hasLowerCase
                        ? "text-green-600"
                        : "text-stone-500"
                    }
                  >
                    {passwordStrength.hasLowerCase ? "✓" : "○"} One lowercase
                    letter
                  </p>
                  <p
                    className={
                      passwordStrength.hasNumber
                        ? "text-green-600"
                        : "text-stone-500"
                    }
                  >
                    {passwordStrength.hasNumber ? "✓" : "○"} One number
                  </p>
                  <p
                    className={
                      passwordStrength.hasSpecialChar
                        ? "text-green-600"
                        : "text-stone-500"
                    }
                  >
                    {passwordStrength.hasSpecialChar ? "✓" : "○"} One special
                    character (@$!%*?&#)
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              disabled={isLoading || (password && !isPasswordValid)}
              className="bg-[#BC3F4A] hover:bg-[#a3323b] text-white px-6 py-2 rounded-md text-sm font-playfair focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition w-full disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? "Updating..." : "Update Password"}
            </button>
          </div>
        </form>
      </section>
    </>
  );
};

export default UpdatePassword;